export const email =  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,3}$/i;

export const telephone = /^[0-9\-\+]{9,14}$/i;
export const spacePostCode = /\d{3}/g
export const onlyNumberIČO = /^\d+$/i
